var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { InternalProvider } from '../../util/InternalProvider';
import useGenerateId from '../../util/useGenerateId';
import noop from '../../util/noop';
import { DropdownContainer, DropdownSelect, DropdownLabel, Chevron, } from './elements';
export var Dropdown = React.forwardRef(function (_a, fRef) {
    var options = _a.options, _b = _a.label, label = _b === void 0 ? '' : _b, _c = _a.name, name = _c === void 0 ? '' : _c, id = _a.id, _d = _a.selectClassName, selectClassName = _d === void 0 ? '' : _d, _e = _a.labelClassName, labelClassName = _e === void 0 ? '' : _e, _f = _a.containerClassName, containerClassName = _f === void 0 ? '' : _f, _g = _a.value, value = _g === void 0 ? '' : _g, _h = _a.onChange, onChange = _h === void 0 ? noop : _h, restProps = __rest(_a, ["options", "label", "name", "id", "selectClassName", "labelClassName", "containerClassName", "value", "onChange"]);
    var dropdownId = useGenerateId('dropdown', id);
    return (React.createElement(InternalProvider, null,
        React.createElement(DropdownContainer, { className: containerClassName, id: dropdownId + "-container" },
            React.createElement(DropdownSelect, __assign({ name: name, id: dropdownId, ref: fRef, value: value, onChange: onChange, className: selectClassName, validOptionSelected: value !== '' }, restProps),
                label && React.createElement("option", { key: "", value: "", disabled: true, hidden: true }),
                options.map(function (item) { return (React.createElement("option", { key: item.value, value: item.value }, item.name)); })),
            React.createElement(DropdownLabel, { validOptionSelected: value !== '', htmlFor: dropdownId, id: dropdownId + "-label", className: labelClassName }, label),
            React.createElement(Chevron, null))));
});
